<script setup>
import { computed } from 'vue';
import { resolveColourValue } from '@/Helpers/themeColourResolver';

const props = defineProps({
    row: {
        type: Object,
        default: undefined,
    },
    brand: { type: Object, default: () => ({}) },
    shift: { type: Number, default: 0 },
});

const featureBgHex = computed(() => resolveColourValue(props.row?.content?.featureBgColour, props.brand, props.shift));
const borderHex = computed(() => resolveColourValue(props.row?.content?.borderColour, props.brand, props.shift));
const titleHex = computed(() => resolveColourValue(props.row?.content?.titleColour, props.brand, props.shift));
const subtitleHex = computed(() => resolveColourValue(props.row?.content?.subtitleColour, props.brand, props.shift));
const featureHex = computed(() => resolveColourValue(props.row?.content?.featureColour, props.brand, props.shift));
</script>

<template>
    <div v-if="row.content?.items" class="w-full p-fl-4">
        <div class="flex flex-col gap-3">
            <div
                v-for="(item, index) in row.content.items"
                :key="index"
                class="flex items-center justify-between rounded-lg px-4 py-3 border"
                :style="{
                    backgroundColor: featureBgHex,
                    borderColor: borderHex,
                }"
            >
                <div class="flex flex-col gap-0.5 min-w-0">
                    <span
                        class="font-semibold text-fl-sm leading-tight"
                        :style="{ color: titleHex, fontFamily: 'var(--heading-font, var(--font))' }"
                        v-text="item.title"
                    />
                    <span
                        v-if="item.subtitle"
                        class="font-light text-fl-sm leading-tight"
                        :style="{ color: subtitleHex }"
                        v-text="item.subtitle"
                    />
                </div>
                <span
                    class="font-bold text-fl-base italic shrink-0 ml-3"
                    :style="{ color: featureHex }"
                    v-text="item.feature"
                />
            </div>
        </div>
    </div>
</template>
